import { useContext, useEffect, useState } from "react";
import { useAnalytics } from '../analytics';
import { Business, getBusiness, updateBusiness } from './capitalAccountClient';
import { AppContext } from "../context/appContext";
import useExceptionFlow from '../hooks/useExceptionFlow';

export default function useCapitalAccountData(): [boolean, Business, (business: Business) => Promise<boolean>] {
  const analytics = useAnalytics();
  const appContext = useContext(AppContext);
  const { exceptionFlow } = useExceptionFlow();
  
  const [data, setData] = useState(appContext.capitalAccountData);

  const isCapitalAccount = (appContext.packType === 'CapitalAccountAdvance');

  useEffect(() => {
    if (!isCapitalAccount || data) {
      console.log('useCapitalAccountData: not capital account or already loaded');
      return;    // If we already have data, no need to fetch it again
    }
    
    console.log('Checking capital account data');
    const source = appContext.isInIframe ? 'in_journey' : 'email';
    const mark = performance.now();
    getBusiness()
      .then((business) => {
        analytics?.trackApi('GET mg contact', performance.now() - mark, true);

        console.log('Capital account data:', business);
        setData(business);
        appContext.setState('capitalAccountData', business);
      })
      .catch((e) => {
        analytics?.trackApi('GET mg contact', performance.now() - mark, false);
        analytics?.trackError(e, { action: 'get-mg-contact-failure', source });
        console.error('Error checking merchant graph contact:', e);
        exceptionFlow(e);
      });
  });

  const updateData = async (business: Business): Promise<boolean> => {
    console.log('Updating capital account data');
    const source = appContext.isInIframe ? 'in_journey' : 'email';
    const mark = performance.now();
    try {
      await updateBusiness(business);
      analytics?.trackApi('POST mg contact', performance.now() - mark, true);
      setData(business);
      appContext.setState('capitalAccountData', business);
      return true;
    } catch (e) {
      analytics?.trackApi('POST mg contact', performance.now() - mark, false);
      analytics?.trackError(e, { action: 'post-mg-contact-failure', source });
      console.error('Error updating merchant graph contact:', e);
      exceptionFlow(e);
      return false;
    }
  };

  return [isCapitalAccount, data, updateData];
}